import React, { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';

import AccessControl from 'components/AccessControl';
import ActivityPerms from 'components/AccessControl/permissions.json';
import { submitManualQuestions } from 'actions/forms/manualQuestions';

const ManualValidationQuestions = ({ dispatch, formId, manualQuestions, permissions }) => {
  const [ticks, setTicks] = useState({});
  const manualQuestionsState = manualQuestions ? manualQuestions.state : null;
  const questions = manualQuestionsState ? manualQuestionsState.questions : [];
  const canOverride = AccessControl.hasPermission(permissions, [ActivityPerms.overrideValidation]);
  const isDisabled = !canOverride || manualQuestionsState == null || manualQuestionsState.isReadOnly;
  const isSubmitting = manualQuestions ? manualQuestions.isSubmitting : false;

  useEffect(() => {
    const answers = {};
    if (manualQuestionsState && manualQuestionsState.answers) {
      manualQuestionsState.answers.forEach((answer) => {
        answers[answer.number] = answer.isYes;
      });
    }
    setTicks(answers);
  }, [manualQuestionsState]);

  const onSubmit = () => {
    const answers = questions.map(question => ({
      number: question.number,
      isYes: ticks[question.number] === true
    }));
    dispatch(submitManualQuestions(formId, answers));
  };

  return (
    <div className="manual-validation-questions">
      <h1>Manual Validation Questions</h1>
      <p>Check the box if the answer is &quot;Yes&quot;</p>
      <ol className="manual-validation-questions-list">
        { questions.map(question => (
          <li key={ question.number } value={ question.number }>
            <span className="manual-validation-question-number">{ question.number }</span>
            <label htmlFor={ `manual-question-${ question.number }` }>
              { question.text }
              <input
                id={ `manual-question-${ question.number }` }
                type="checkbox"
                checked={ ticks[question.number] === true }
                disabled={ isDisabled }
                onChange={ event => setTicks({ ...ticks, [question.number]: event.target.checked }) }
              />
            </label>
          </li>
        )) }
      </ol>
      <div className="submit-actions col-12">
        <div className="col-6" />
        <div className="col-6">
          <button
            id="submit-manual-questions-btn"
            type="button"
            className="btn btn-primary"
            disabled={ isDisabled || isSubmitting }
            onClick={ onSubmit }
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

ManualValidationQuestions.propTypes = {
  dispatch: PropTypes.func.isRequired,
  formId: PropTypes.number.isRequired,
  manualQuestions: PropTypes.shape(),
  permissions: PropTypes.arrayOf(PropTypes.string)
};

ManualValidationQuestions.defaultProps = {
  manualQuestions: null,
  permissions: []
};

export default ManualValidationQuestions;
